// extracted by mini-css-extract-plugin
export default {"container":"MZ_q3","text":"ZMbQS","link":"oqtJG","button":"AdUte"};